export const environment = {
  production: false,
  API_BASE_URL: 'https://qaapi.pactrak.com',
  b2cRedirectURL: 'https://qapactrakcustomer-bac7a0fnfkcmfwcp.eastus-01.azurewebsites.net/',
  MOCK_API_URL: 'https://qapactrak.azurewebsites.net',
  B2CName: 'B2C_1_qa-customer-pactrak',
  clientId: 'ec0e0b65-95a7-4f2e-8515-ed63acc2975b',
  // Telemetry configuration
  telemetry: {
    enabled: true,
    fallbackToConsole: true,
  },
  b2cAuthority: 'https://pactrakcustomer.b2clogin.com/pactrakcustomer.onmicrosoft.com/',
  authorityDomain: 'pactrakcustomer.b2clogin.com',
  // Smarty embedded (website) key for address autocomplete; empty disables autocomplete
  smartyEmbeddedKey: '299470866424752975',
};
